import Cookie from 'js-cookie';

export function cookiesBar() {
    if (window.Theme.is_user_logged_in || !window.Theme.cookies.enabled) {
        return;
    }

    window.cookieconsent.initialise({
        position: 'top',
        theme: 'block',
        type: 'opt-out',
        law: {
            regionalLaw: false,
        },
        content: {
            message: window.Theme.cookies.message,
            allow: window.Theme.cookies.allow,
            deny: window.Theme.cookies.decline,
            policy: window.Theme.cookies.cookie_policy,
        },
        elements: {
            messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',
        },
        onStatusChange: function (status) {
            if (status == 'deny') {
                const cookies = Cookie.get();

                for (let cookie in cookies) {
                    if (cookies.hasOwnProperty(cookie) && cookie != 'cookieconsent_status') {
                        Cookie.remove(cookie, { path: '/', domain: '.lndo.site' });
                        Cookie.remove(cookie, { path: '/', domain: '.ever-clean.co.uk' });
                        Cookie.remove(cookie, { path: '/', domain: 'www.ever-clean.co.uk' });
                        Cookie.remove(cookie, { path: '/', domain: '.nr-data.net' });
                    }
                }
            }
        },
    });
}
